<template>
    <MainContent title="Editar grupo">
        <template v-slot:header>
            <h3 class="card-title mb-3">Editar grupo</h3>
        </template>
        <template v-slot:content>
            <ContentOrLoading>
                <FormGrupo v-if="grupo" :grupo="grupo" :loading="loading" @terminado="editarGrupo" />
            </ContentOrLoading>
        </template>
    </MainContent>
</template>

<script>
    import apiService from '@/services/api-comunicados';
    import MainContent from '@/components/backend/components/MainContent';
    import FormGrupo from '@/components/backend/campana-emails/grupos/FormGrupo';

    export default {
        data() {
            return {
                grupo: null,
                loading: false
            }
        },
        methods: {
            async getGrupo() {
                this.loading = true;

                try {
                    const response = await apiService.getGrupo(this.grupo_id);
                    this.grupo = response.data;
                } catch (error) {
                    console.error('Error al cargar grupo:', error);
                } finally {
                    this.loading = false;
                }
            },
            async editarGrupo() {
                this.loading = true;

                try {
                    await apiService.updateGrupo(this.grupo_id, this.grupo);
                    this.$toast.success('Grupo editado correctamente');
                    this.$router.push('/admin/emails/grupos');
                } catch (error) {
                    console.error('Error al actualizar grupo:', error);
                } finally {
                    this.loading = false;
                }
            }
        },
        computed: {
            grupo_id() {
                return this.$route.params.grupo_id;
            }
        },
        created() {
            this.getGrupo();
        },
        components: {
            MainContent, FormGrupo
        }
    }
</script>